import React from 'react'
import {Link, NavLink} from 'react-router-dom';
import './header.css'

class LoggedHeader extends React.Component {
    render() {
        return (
            <div className="logout-header">
                <img className="cc" src={require("./cc.png")}></img>
                <div className="login-teacher">智算学部</div>
                <div className="login-border"></div>
                <Link to="/"><div className="login-student">退出登录</div></Link>
            </div>
        );
    }
}

export default LoggedHeader;